import { QrcodeOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Tooltip,
  Typography,
  message,
} from 'antd';
import moment, { Moment } from 'moment/moment';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { IListColumn } from 'src/@types/search-params';
import { getAllPackageByLCS } from 'src/api/activeSim';
import { getListEsim } from 'src/api/esimManagement';
import CGridView from 'src/components/CGridView';
import TableContent from 'src/components/CTable';
import { usePermission } from 'src/hooks/usePermission';
import useWindowSize from 'src/hooks/useWindowSize';
import { store } from 'src/redux';
import { useAppSelector } from 'src/redux/hook';
import { setEsimManagementState } from 'src/redux/slice/esimManagementSlice';
import { SearchDataEsim, ValueCodeEsim } from 'src/shared/interface/esimManagement.interface';
import { dataGet, exportExcelPost, formatDate, parseQueryString } from 'src/utils';
import { StatusEsimLot, TransactionTypeLot, ValueAll } from '../../constants';
import {
  getStatusEsimLotOption,
  getStatusEsimLotTxt,
  getTransactionTypeLotOption,
  getTransactionTypeLotTxt,
} from '../../utils';
import ModalPreviewQrCode from '../components/ModalPreviewQrCode';
const { RangePicker } = DatePicker;

interface FormData {
  code?: string;
  status?: string;
  dateRange: [Moment, Moment];
  type?: string;
  dataPackage?: string;
}

export default function EsimManagement() {
  const location = useLocation();
  const [form] = Form.useForm();
  const [listPackages, setListPackages] = useState<ValueCodeEsim[]>([]);
  const [isOpenQrCode, setIsOpenQrCode] = useState(false);
  const [isQrCodeActive, setIsQrCodeActive] = useState<boolean>();
  const [_, setSearchParams] = useSearchParams();
  const [selectedQrCode, setSelectedQrCode] = useState<any>();
  const { listEsimSelect } = useAppSelector((state) => state.esimManagement);
  const [eSimData, setEsimData] = useState<any>({});
  const size = useWindowSize();

  const { hasPermission, PERMISSIONS } = usePermission();

  const newSelectedRowKeys = [...listEsimSelect].map((item: any) => item?.id);
  const rowSelection = {
    selectedRowKeys: newSelectedRowKeys,
    onSelect: (record: any, selected: boolean) => {
      let listEsimSelectedTmp = listEsimSelect;
      if (selected) {
        listEsimSelectedTmp = [...listEsimSelect, record];
      } else {
        listEsimSelectedTmp = listEsimSelectedTmp?.filter((item: any) => item?.id !== record?.id);
      }
      store.dispatch(
        setEsimManagementState({
          listEsimSelect: listEsimSelectedTmp,
        }),
      );
    },
    onSelectAll: (selected: boolean, selectedRows: any[], changeRows: any[]) => {
      let listEsimSelectedTmp = listEsimSelect;
      if (selected) {
        listEsimSelectedTmp = [...listEsimSelect, ...changeRows];
      } else {
        changeRows?.forEach((itemChange: any) => {
          listEsimSelectedTmp = listEsimSelectedTmp?.filter(
            (item: any) => item?.id !== itemChange?.id,
          );
        });
      }
      store.dispatch(
        setEsimManagementState({
          listEsimSelect: listEsimSelectedTmp,
        }),
      );
    },
  };

  const columns: IListColumn[] = [
    {
      name: 'Mã xuất lô',
      fieldName: 'transactionCode',
      isHideSort: true,
      align: 'left',
    },
    {
      name: 'Serial',
      fieldName: 'serial',
      isHideSort: true,
      align: 'left',
    },
    {
      name: 'Trạng thái',
      fieldName: 'statusInt',
      isHideSort: true,
      align: 'left',
      renderSpecialCard: (record) => {
        return <span>{getStatusEsimLotTxt(record?.statusInt.toString())}</span>;
      },
    },
    {
      name: 'Loại giao dịch',
      fieldName: 'type',
      isHideSort: true,
      align: 'left',
      renderSpecialCard: (record: any) => {
        return <Typography.Text>{getTransactionTypeLotTxt(record?.type)}</Typography.Text>;
      },
    },
    {
      name: 'Gói',
      fieldName: 'dataPackage',
      isHideSort: true,
      align: 'left',
    },
    {
      name: 'Tên gói',
      fieldName: 'dataPackageName',
      isHideSort: true,
      align: 'left',
    },
    {
      name: 'Ngày xuất lô',
      fieldName: 'exportAt',
      isHideSort: true,
      align: 'left',
      renderSpecialCard: (record: any) => {
        return (
          <Typography.Text>
            {dataGet(record, 'exportAt') ? formatDate(dataGet(record, 'exportAt', '')) : ''}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Ngày hết hạn eSIM',
      fieldName: 'expireAt',
      isHideSort: true,
      align: 'center',
      renderSpecialCard: (record: any) => {
        return (
          <Typography.Text>
            {dataGet(record, 'expireAt') ? formatDate(dataGet(record, 'expireAt')) : ''}
          </Typography.Text>
        );
      },
    },
    {
      name: 'LPA',
      fieldName: 'lpa',
      isHideSort: true,
      align: 'left',
      renderSpecialCard: (record: any) => {
        return (
          <span className='cursor-pointer inline-block w-[100px] md:w-[200px]'>
            {renderTruncate(record?.lpa)}
          </span>
        );
      },
    },
    {
      name: 'QR eSIM',
      fieldName: 'qrEsim',
      isHideSort: true,
      align: 'center',
      renderSpecialCard: (record: any) => {
        return (
          <QrcodeOutlined
            className={'cursor-pointer'}
            style={{ fontSize: 24 }}
            onClick={() => {
              setIsOpenQrCode(true);
              setSelectedQrCode(record?.qrEsim);
              setIsQrCodeActive(false);
            }}
          />
        );
      },
    },
    {
      name: 'Thao tác',
      fieldName: 'code',
      isHideSort: true,
      align: 'left',
      fixed: 'right',
      renderSpecialCard: (record: any) => {
        const canExport = hasPermission(PERMISSIONS.ESIM.EXPORT);

        return (
          <>
            <Typography.Text
              className={`underline whitespace-nowrap font-semibold ${
                canExport
                  ? 'text-blue-400 cursor-pointer hover:text-blue-600'
                  : 'text-gray-400 cursor-not-allowed'
              }`}
              onClick={() => {
                if (canExport) {
                  onClickDownloadFile(record);
                }
              }}
              disabled={!canExport}
            >
              Tải về
            </Typography.Text>
          </>
        );
      },
    },
  ];
  const renderTruncate = (text: string) => {
    return (
      <div className='truncate block'>
        <Tooltip
          placement='topLeft'
          rootClassName='max-w-[100px] md:max-w-[250px]'
          title={<span>{text}</span>}
        >
          {text}
        </Tooltip>
      </div>
    );
  };

  const disabledDate = (current: any) => {
    // Can not select days after today
    return current && current > moment().endOf('day');
  };

  const fetchListEsim = async (params = {}) => {
    const res = await getListEsim(params as SearchDataEsim);
    if (res) {
      setEsimData(res);
    }
  };

  const fetchListPackages = async () => {
    const packageTmp: any = [
      {
        label: 'Tất cả',
        value: ValueAll.ALL,
      },
    ];
    const packages = await getAllPackageByLCS();
    if (packages) {
      packageTmp?.push({
        label: 'Tất cả',
        value: ValueAll.ALL,
      });

      packages &&
        packages?.map((item: any) => {
          packageTmp.push({
            label: item.mbfName,
            value: item.mbfCode,
          });
        });
      setListPackages(packageTmp);
    }
  };

  const handleSearch = (formValues: FormData) => {
    const currentQueryStr = parseQueryString(location.search);
    delete currentQueryStr.pageIndex;
    delete currentQueryStr.pageSize;
    setSearchParams({
      ...currentQueryStr,
    });
    const { code, status, type, dataPackage, dateRange } = formValues;
    const filterSearch = {
      code: code?.trim(),
      status: status === StatusEsimLot.ALL ? undefined : status,
      type: type === TransactionTypeLot.ALL ? undefined : type,
      dataPackage: dataPackage === ValueAll.ALL ? undefined : dataPackage,
      dateFrom: dateRange ? dateRange[0]?.format('YYYY-MM-DD 00:00:00').toString() : undefined,
      dateTo: dateRange ? dateRange[1]?.format('YYYY-MM-DD 00:00:00').toString() : undefined,
      pageIndex: 1,
      pageSize: 10,
    };
    setSearchParams(queryString.stringify(filterSearch));
    fetchListEsim(filterSearch);
  };
  const onClickDownloadFile = async (record: any) => {
    const params = parseQueryString(location.search);
    if (record) {
      const link = document.createElement('a');
      link.target = '_blank';
      link.download = `Danh_sach_esim_${moment().format('DDMMYYYYHHmmss')}.xlsx`;
      exportExcelPost('/api/inventory-esim/export-esim-manage-distributor', {
        ...params,
        lotDetailIds: [record?.id],
        serialList: [record?.serial],
        channel: 'active',
      })
        .then((res) => {
          link.href = URL.createObjectURL(
            new Blob([res.data], { type: 'application/vnd.ms-excel' }),
          );
          link.click();
          message.success('Kết xuất file thành công!');
        })
        .catch((error) => {
          if (error.status === 403) {
            message.error(`Tài khoản của bạn không có quyền truy cập vào chức năng này`);
          }
        });
    }
  };

  const onClickExportExcel = async () => {
    const params = parseQueryString(location.search);
    const listEsimExport: any = [];
    listEsimSelect?.forEach((item: any) => {
      listEsimExport.push(item?.id);
    });

    const link = document.createElement('a');
    link.target = '_blank';
    link.download = `Danh_sach_esim_${moment().format('DDMMYYYYHHmmss')}.xlsx`;
    exportExcelPost('/api/inventory-esim/export-esim-manage-distributor', {
      ...params,
      lotDetailIds: listEsimExport,
      channel: 'active',
    })
      .then((res) => {
        link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.ms-excel' }));
        link.click();
        store.dispatch(
          setEsimManagementState({
            listEsimSelect: [],
          }),
        );
        message.success('Kết xuất file thành công!');
      })
      .catch((error) => {
        if (error.status === 403) {
          message.error(`Tài khoản của bạn không có quyền truy cập vào chức năng này`);
        }
      });
  };

  useEffect(() => {
    fetchListPackages();
    fetchListEsim({
      pageIndex: 1,
      pageSize: 10,
      // sortField: pagination.sortField ?? undefined,
      // asc: pagination.asc ?? undefined,
    });
  }, []);

  const renderOptions = (listOpts: any[]) => {
    return listOpts?.map((item) => {
      return (
        <Select.Option value={item?.value} key={item?.value} label={item?.label}>
          {item?.label}
        </Select.Option>
      );
    });
  };

  return (
    <>
      <div>
        <Form
          form={form}
          layout={size.width < 768 ? 'vertical' : 'inline'}
          onFinish={handleSearch}
          className='gap-2'
        >
          <Form.Item name={'code'}>
            <Input allowClear placeholder={'Theo mã, serial'} prefix={<SearchOutlined />} />
          </Form.Item>
          <Form.Item name={'status'} label={'Trạng thái'}>
            <Select
              defaultValue={StatusEsimLot.ALL}
              showSearch
              id={'esim-lot-status'}
              className={'w-full'}
              options={getStatusEsimLotOption()}
              optionLabelProp={'label'}
              filterOption={(input, option) => {
                return (option!.label as unknown as string)
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
            />
          </Form.Item>
          <Form.Item label={'Loại giao dịch'} name={'type'}>
            <Select
              showSearch
              defaultValue={TransactionTypeLot.ALL}
              id={'transaction-type-lot'}
              className={'w-full'}
              options={getTransactionTypeLotOption()}
              optionLabelProp={'label'}
              filterOption={(input, option) => {
                return (option!.label as unknown as string)
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
            />
          </Form.Item>
          <Form.Item label={'Mã gói'} name={'dataPackage'}>
            <Select
              showSearch
              defaultValue={ValueAll.ALL}
              id={'package-code'}
              className={'w-full'}
              optionLabelProp={'label'}
              filterOption={(input, option) => {
                return (option!.label as unknown as string)
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
            >
              {renderOptions(listPackages)}
            </Select>
          </Form.Item>
          <Form.Item label={'Ngày xuất lô'} name={'dateRange'}>
            <RangePicker
              id={'export-date-picker'}
              placeholder={['Từ', 'Đến']}
              format={'DD/MM/YYYY'}
              disabledDate={disabledDate}
            />
          </Form.Item>
          <Form.Item>
            <Button type={'primary'} htmlType={'submit'}>
              Tìm kiếm
            </Button>
          </Form.Item>
        </Form>

        <div className={'mt-4'}>
          {size.width < 1024 ? (
            <CGridView
              length={dataGet(eSimData, 'results', [])?.length}
              totalRecord={dataGet(eSimData, 'results', []).length ?? 0}
              columns={columns}
              title={() => <div className='text-xl font-bold my-3'>Danh sách eSIM</div>}
            >
              {dataGet(eSimData, 'results', []) && dataGet(eSimData, 'results', []).length > 0 ? (
                dataGet(eSimData, 'results', []).map((item: any) => {
                  return (
                    <div key={'data-row-' + item.id}>
                      <Divider className='border-t-black' />

                      <Row className='mb-6 items-center' gutter={[4, 16]}>
                        {columns.map((ele) => {
                          if (ele.fieldName !== 'index' && ele.fieldName !== 'action') {
                            return (
                              <>
                                <Col span={11} className={`font-bold label`}>
                                  <div className='flex gap-2 items-center'>{ele.name}</div>
                                </Col>
                                <Col className='break-words text-right' span={13}>
                                  {ele?.renderSpecialCard
                                    ? ele?.renderSpecialCard(item, null, null, null)
                                    : item[`${ele?.fieldName}`]}
                                </Col>
                              </>
                            );
                          } else if (ele.fieldName === 'action') {
                            return (
                              <Col key={'column-' + item.id + ele.fieldName} span={24}>
                                <div className='flex gap-6'>
                                  {ele?.renderSpecialCard
                                    ? ele?.renderSpecialCard(item, null, null, null)
                                    : item[`${ele?.fieldName}`]}
                                </div>
                              </Col>
                            );
                          } else {
                            return <></>;
                          }
                        })}
                      </Row>
                    </div>
                  );
                })
              ) : (
                <p>{'Không có dữ liệu'}</p>
              )}
            </CGridView>
          ) : (
            <TableContent
              bordered
              rowKey='id'
              scroll={{ x: 'max-content' }}
              locale={{ emptyText: 'Không tìm thấy kết quả' }}
              totalRecord={dataGet(eSimData, 'rowCount', 0)}
              dataSource={dataGet(eSimData, 'results', [])}
              columns={columns}
              isShowCheckBox={true}
              rowSelection={rowSelection}
              onPageChange={(pageNumber, pageSize) => {
                const params = parseQueryString(location.search);
                fetchListEsim({
                  ...params,
                  pageIndex: pageNumber ?? 1,
                  pageSize: pageSize ?? 10,
                  // sortField: pagination.sortField ?? undefined,
                  // asc: pagination.asc ?? undefined,
                });
              }}
            />
          )}
        </div>

        <div className={'flex justify-center'}>
          <Button
            className={'ml-1'}
            onClick={onClickExportExcel}
            disabled={!hasPermission(PERMISSIONS.ESIM.EXPORT)}
          >
            {hasPermission(PERMISSIONS.ESIM.EXPORT)
              ? 'Kết xuất file'
              : 'Bạn không có quyền kết xuất file'}
          </Button>
        </div>

        {isOpenQrCode && (
          <ModalPreviewQrCode
            open={isOpenQrCode}
            setIsOpenQrCode={setIsOpenQrCode}
            isQrCodeActive={isQrCodeActive}
            selectedQrCode={selectedQrCode}
            setSelectedQrCode={setSelectedQrCode}
          />
        )}
      </div>
    </>
  );
}
